import React from 'react';
import * as lib from '~/dependencies';
import { BtnSubmit, CircularProgressStyled } from './styles';

export default function SubmitButton({
  onSubmit,
  loading,
  title,
  disabled,
  onKeyPress,
  ...rest
}) {
  return (
    <BtnSubmit
      {...rest}
      disabled={loading || disabled}
      onClick={() => onSubmit()}
      onKeyPress={e => onKeyPress(e)}>
      {loading ? <CircularProgressStyled /> : <span>{title}</span>}
    </BtnSubmit>
  );
}

SubmitButton.defaultProps = {
  title: 'Login',
  onSubmit: () => {},
  onKeyPress: () => {},
  loading: false,
  disabled: false,
};

SubmitButton.propTypes = {
  title: lib.PropTypes.string,
  onSubmit: lib.PropTypes.func,
  onKeyPress: lib.PropTypes.func,
  loading: lib.PropTypes.bool,
  disabled: lib.PropTypes.bool,
};
